import React,{useState} from 'react';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import AddCostumerModal from "./AddCostumerModal";
import { Tooltip, Typography } from '@material-ui/core';


const AddCostumer = () => 
{
    const [openModal, setopenModal] = useState(false);

    const changeStatusModal=()=>
    {
        setopenModal(!openModal);
    }

    const Style=
    {

        cursor:"pointer",
        color:"white",
        backgroundColor:"#0088FF",
        position:"fixed",
        bottom:0,
        right:0,
        margin:"15px"
    }
    return <>
    <Tooltip title={<Typography fontSize={21}>Agregar</Typography>}>
        <Fab style={Style}  onClick={changeStatusModal}>
            <AddIcon/>
        </Fab>
    </Tooltip>
    <AddCostumerModal open={openModal} close={changeStatusModal}/>
    </>
}

export default AddCostumer
